import type {DraggableSyntheticListeners} from '@dnd-kit/core';
import {Icon} from 'platform/foundation';
import styled from 'styled-components';

import {TestIdProps} from 'shared/web';

interface PresetDragHandleProps extends TestIdProps {
  isGrabbing?: boolean;
  listeners?: DraggableSyntheticListeners;
}

export function PresetDragHandle(props: PresetDragHandleProps) {
  return (
    <Handle $isGrabbing={props.isGrabbing} {...props.listeners}>
      <Icon
        value="action/drag_indicator"
        color="palettes.neutral.60.100"
        data-testid={props['data-testid']}
      />
    </Handle>
  );
}

const Handle = styled.div<{$isGrabbing?: boolean}>`
  cursor: ${({$isGrabbing}) => ($isGrabbing ? 'grabbing' : 'grab')};
  display: flex;
  align-items: center;
`;
